import BaseComponent from '../abstracts/BaseComponent';

export default class ModalTriggerComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.init();
  }

  init() {
    if (this.$options.immediate) {
      this.open();
    }
    this.handleClick();
  }


  open(e) {
    if (this.$options.element && !this.$options.close) {
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
        selector: this.$options.element,
        className: this.$options.classname || ''
      });
    } else {
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close);
    }
  }

  async handleClick() {
    this.$on('click.modal', (e) => {
      this.open(e);
    });
  }
}
